import {axiosUtil} from "../../../../utils/axios_util";

const ANumberManageApi = {
    //分页查询A池
    manageAPoolNumberPage(data:powerSearchData) {
        return axiosUtil({
            url: '/manager/call_initializer_number/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //A池数据统计
    getAllAPool(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/getAll/${data}`,
            method: 'post',
            data,
        })
    },
    //编辑A池号码
    editAPoolNumber(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/edit`,
            method: 'post',
            data,
        })
    },
    //删除A池号码
    deleteAPoolNumber(data: any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/delete/${data.phoneNumberNo}/${data.callInitializerNumberPoolNo}`,
            method: 'post',
            data
        })
    },
    //新增A池号码
    addAPoolNumber(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/add`,
            method: 'post',
            data,
        })
    },
    //批量新增A池号码预览
    addPreview(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/add/preview`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //预览数据分页查询
    previewPage(data:powerSearchData) {
        return axiosUtil({
            url: '/manager/call_initializer_number/batch/preview/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //预览数据错误类型统计
    previewCount(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/preview/count/${data}`,
            method: 'post',
            data
        })
    },
    //批量新增A池号码
    batchAddAPoolNumber(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/add/${data}`,
            method: 'post',
            data
        })
    },
    //错误数据导出
    exportError(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/export/error`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            responseType: 'blob',
            data
        })
    },

    //批量编辑A池号码预览
    editPreview(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/edit/preview`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //批量删除A池号码预览
    deletePreview(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/delete/preview`,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data
        })
    },
    //批量编辑A池号码
    batchEditAPoolNumber(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/edit/${data}`,
            method: 'post',
            data
        })
    },
    //批量删除A池号码
    batchDeleteAPoolNumber(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/batch/delete/${data}`,
            method: 'post',
            data
        })
    },
    //A池号码数据统计
    statistics(data: any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/statistics`,
            method: 'post',
            data
        })
    },

}

export default ANumberManageApi
